import DOMPurify from 'dompurify';

/**
 * Преобразует HTML-строку в обычный текст с сохранением пробелов между блоками.
 * Заменяет закрывающие блочные теги и теги переноса строк на пробелы перед очисткой,
 * чтобы избежать слипания слов при удалении тегов.
 * Использует DOMPurify для безопасной очистки от потенциально опасного содержимого.
 *
 * @param {string} html - HTML-строка, содержащая разметку.
 * @returns {string} - Очищенный текст без тегов и атрибутов, с нормализованными пробелами.
 *
 * @example
 * getPlainTextWithSpacesFromHtml('<p>Hello</p><p>world</p>');
 * // Вернёт: 'Hello world'
 */

export const getPlainTextWithSpacesFromHtml = (html: string): string => {
    if (!html) return '';

    const spacedHtml = html
        .replace(/<\/(p|div|h[1-6]|li|ul|ol|section|article|header|footer)>/gi, ' ')
        .replace(/<br\s*\/?>/gi, ' ');

    const clean = DOMPurify.sanitize(spacedHtml, { ALLOWED_TAGS: [], ALLOWED_ATTR: [] });

    return clean.replace(/\s+/g, ' ').trim();
};
